import { Inject, Injectable } from '@angular/core';
import { IUpdateProfilePayload } from '@boxx/profile-core/lib/repositories/IProfile.repository';
import {
  IStoreService,
  StorePageStore,
  STORE_SERVICE,
} from '@boxx/store-core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { combineLatest, of } from 'rxjs';
import {
  catchError,
  mergeMap,
  switchMap,
  withLatestFrom,
} from 'rxjs/operators';
import { StoreProfileModel } from '../../models/Store.model';
import * as fromConfigurationActions from './store-configuration.actions';

@Injectable()
export class StoreConfigurationEffects {
  // --------------------------- PROFILE: ---------------------------------
  loadProfile$ = createEffect(() =>
    this.actions.pipe(
      ofType(fromConfigurationActions.loadProfileBeginAction),
      switchMap(() =>
        this.service.getProfile().pipe(
          mergeMap((payload) => [
            fromConfigurationActions.loadProfileSuccessAction({ payload }),
            fromConfigurationActions.clearProfileSuccessErrorDataAction(),
          ]),
          catchError((errors) => {
            console.error('StoreEffects.loadProfile$ ERROR', errors);
            return of([
              fromConfigurationActions.loadProfileFailAction({ errors }),
              fromConfigurationActions.clearProfileSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

  updateProfile$ = createEffect(() =>
  this.actions.pipe(
    ofType(fromConfigurationActions.updateProfileBeginAction),
    withLatestFrom(this.storePageStore.configurationStore.data$),
    switchMap(([action, profileData]: [any, StoreProfileModel]) =>
      this.service.updateProfile((action as any).payload).pipe(
        mergeMap((data) => {
          const payload = (action as any).payload;        
          return [
            fromConfigurationActions.updateProfileSuccessAction({ payload }),
            fromConfigurationActions.clearProfileSuccessErrorDataAction(),
          ];
        }),
        catchError((errors) => {
          console.error('StoreEffects.updateProfile$ ERROR', errors);
          return of([
            fromConfigurationActions.updateProfileFailAction({ errors }),
            fromConfigurationActions.clearProfileSuccessErrorDataAction(),
          ]).pipe(switchMap((d) => d));
        })
      )
    )
  )
);

uploadImageProfile$ = createEffect(() =>
this.actions.pipe(
  ofType(fromConfigurationActions.uploadImageProfileBeginAction),
  withLatestFrom(this.storePageStore.configurationStore.data$),
  switchMap(([action, imageData]: [any, any]) =>
    this.service.uploadImageProfile(action.payload).pipe(
      mergeMap((data) => {
                  const payload = imageData;
                  return [
                    fromConfigurationActions.uploadImageProfileSuccessAction(null),
                    fromConfigurationActions.clearProfileSuccessErrorDataAction(),
                  ];
                }),
      catchError((errors) => {
        console.error('StoreEffects.uploadImageCategory$ ERROR', errors);
        return of([
          fromConfigurationActions.uploadImageProfileFailAction({ errors }),
          fromConfigurationActions.clearProfileSuccessErrorDataAction(),
        ]).pipe(switchMap((d) => d));
      })
    )
  )
)
);


deleteImageProfile$ = createEffect(() =>
this.actions.pipe(
  ofType(fromConfigurationActions.deleteImageProfileBeginAction),
  withLatestFrom(this.storePageStore.configurationStore.data$),
  switchMap(([action, storeData]: [any, any]) =>
    this.service.deleteImageProfile(action.id).pipe(
      mergeMap(() =>
      {
        const payload = null;
        return [
          fromConfigurationActions.deleteImageProfileSuccessAction({payload}),
          fromConfigurationActions.clearProfileSuccessErrorDataAction(),
        ];
      }
      ),
      catchError((errors) => {
        console.error('StoreEffects.deleteImageProfile$ ERROR', errors);
        return of([
          fromConfigurationActions.deleteImageProfileFailAction({ errors }),
          fromConfigurationActions.clearProfileSuccessErrorDataAction(),
        ]).pipe(switchMap((d) => d));
      })
    )
  )
)
);

  constructor(
    private actions: Actions,
    private storePageStore: StorePageStore,
    @Inject(STORE_SERVICE) private service: IStoreService
  ) {}
}
